import Transformer from '../transformer'

export default class CustomerTransformer extends Transformer {
  static fetch(chief) {
    const getName = ({ name = '', last_name = '', mothers_last_name = '', title = '' }) => {
      return `${title || ''} ${name || ''} ${last_name || ''} ${mothers_last_name || ''}`
    }
    return {
      id: chief.id,
      highwayName: chief.highway.name,
      highway: chief.highway.id,
      chiefName: getName(chief.customer_staff),
      chief: chief.customer_staff.id,
      customer: chief.customer_staff.customer,
    }
  }
  static send({ chief, highway }) {
    return {
      highway: highway,
      customer_staff: chief
    }
  }
  static update({ chief, highway }) {
    return {
      highway: highway,
      customer_staff: chief
    }
  }
}



// WEBPACK FOOTER //
// ./src/transformers/catalog/chiefRelations.js